var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 81,
    viewBox: "0 0 91 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1185"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 487",
    x: 90,
    y: 80.1255,
    width: 80,
    height: 10,
    transform: "rotate(-179.92 90 80.1255)",
    fill: "#B88D00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 488",
    x: 10.1113,
    y: 0.0139542,
    width: 80,
    height: 10,
    transform: "rotate(90.0799 10.1113 0.0139542)",
    fill: "#B88D00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBleft);
export default __webpack_public_path__ + "static/media/bleft.fe717b23c98a90134d5dd423442b32de.svg";
export { ForwardRef as ReactComponent };